import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsPostTradingExpiredEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/post-trading/columns-post-trading-expired.enum'

export const ColumnsPostTradingExpiredConstant: ColumnInterface<ColumnsPostTradingExpiredEnum>[] = [
	{
		column: ColumnsPostTradingExpiredEnum.option,
		visible: true,
	},
	{
		column: ColumnsPostTradingExpiredEnum.options,
		visible: true,
	},
	{
		column: ColumnsPostTradingExpiredEnum.stocks,
		visible: true,
	},
	{
		column: ColumnsPostTradingExpiredEnum.sum,
		visible: true,
	},
	{
		column: ColumnsPostTradingExpiredEnum.price,
		visible: true,
	},
	{
		column: ColumnsPostTradingExpiredEnum.event,
		visible: true,
	},
	{
		column: ColumnsPostTradingExpiredEnum.date,
		visible: true,
	},
]
